import { render, staticRenderFns } from "./SpilkaFormioMFOld.vue?vue&type=template&id=1520b445&scoped=true"
import script from "./SpilkaFormioMFOld.vue?vue&type=script&lang=js"
export * from "./SpilkaFormioMFOld.vue?vue&type=script&lang=js"
import style0 from "./SpilkaFormioMFOld.vue?vue&type=style&index=0&id=1520b445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520b445",
  null
  
)

export default component.exports